import LoadingWheel from '../../atoms/LoadingWheel';
import styles from './PageLoader.module.css';

const PageLoader = () => {
  return (
    <div className={styles['page__loader-wrapper']}>
      <div className={styles.page__loader}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <LoadingWheel size={35} />
          <span style={{ marginLeft: '8px', fontSize: '20px' }}>Loading</span>
        </div>
      </div>
    </div>
  );
};

PageLoader.displayName = 'PageLoader';
export default PageLoader;
